import { baseRequest } from './base';

//列表
function list(params) {
    let tempUrl = '/api/common/comOperateLogDO/';
    return baseRequest(tempUrl, 'post', params);
}

//模块列表
function moduleList() {
    let tempUrl = '/api/common/comOperateLogDO/getModule';
    return baseRequest(tempUrl, 'get');
}


export default {
    list, moduleList
}
